import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { localStoreStorage } from "../lib";
import { setLocalStoreItemAction, setTableSettingsAction } from "../lib/actions";
import { initialFilters, initialTableSettings, } from "../lib/reducers/initialState";
/**
 * @category Hooks
 */
export const useLocalStoreState = (
/**
 * Уникальный идентификатор локального store
 */
id, initPageSize = initialTableSettings.pageSize) => {
    const dispatch = useDispatch();
    useEffect(() => {
        setTimeout(() => {
            const currentStores = localStoreStorage.get("currentLocalStores");
            const currentStoresSet = currentStores
                ? Array.from(new Set([...currentStores, id]))
                : [id];
            localStoreStorage.set("currentLocalStores", currentStoresSet);
        }, 0);
    }, [id]);
    const [filters, tableSettings] = useSelector((state) => {
        if (state.localStore[id])
            return [state.localStore[id].filters, state.localStore[id].tableSettings];
        const localStoreItem = localStoreStorage.get(id);
        const resultState = localStoreItem
            ? localStoreItem
            : {
                filters: initialFilters,
                tableSettings: Object.assign(Object.assign({}, initialTableSettings), { pageSize: initPageSize }),
            };
        if (!localStoreItem)
            localStoreStorage.set(id, resultState);
        dispatch(setLocalStoreItemAction(id, resultState));
        return [resultState.filters, resultState.tableSettings];
    });
    const setFilters = useCallback((newFilters) => {
        if (Object.keys(newFilters).length > 0) {
            const newState = {
                filters: Object.assign(Object.assign({}, filters), newFilters),
                tableSettings: Object.assign(Object.assign({}, tableSettings), { pageIndex: 0 }),
            };
            localStoreStorage.set(id, newState);
            dispatch(setLocalStoreItemAction(id, newState));
        }
    }, [dispatch, id, filters, tableSettings]);
    const setTableSettingsState = useCallback((newState) => {
        if (Object.keys(newState).length > 0) {
            const pageIndex = typeof newState.pageSize === "number"
                ? initialTableSettings.pageIndex
                : typeof newState.pageIndex === "number"
                    ? newState.pageIndex
                    : tableSettings.pageIndex;
            const newTableSettings = Object.assign(Object.assign(Object.assign({}, tableSettings), newState), { pageIndex });
            localStoreStorage.set(id, { tableSettings: newTableSettings, filters });
            dispatch(setTableSettingsAction(id, newTableSettings));
        }
    }, [tableSettings, id, filters, dispatch]);
    return [filters, tableSettings, setFilters, setTableSettingsState, dispatch];
};
export default useLocalStoreState;
//# sourceMappingURL=useLocalStoreState.js.map